import { IMForm } from '@insurancemenu/imenu-components-lib';
import { ContentSection } from 'components/common/general/ContentSection';
import styled from 'styled-components';

export const IMFormStyled = styled(IMForm)`
  margin: 0 auto;
  padding: 0;
`;

export const ContentSectionStyled = styled(ContentSection)`
  margin-bottom: 7rem;
`;

export const ProducerNotFoundLabelStyled = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
`;
